import type {ImageField} from '@prismicio/client'

export const Asset = ({asset}: {asset: ImageField}) => (
  <div
    className="h-[256px] w-full rounded-[4px] bg-cover bg-center md:h-auto xl:min-w-[564px]"
    style={{
      backgroundImage: `url(${asset.url})`,
    }}
  />
)
